import DefaultMapBomb from './images/MapError.png';
import BombaAplicacao from './images/bomba-aplicacao.png';
import UchaAplicacao from './images/ucha-aplicacao.png';
import SemUsuario from './images/SemUsuario.png';
import ProdutoDefault from './images/ProdutoDefault.png';
import BombaFull from './images/BombaFull.png';
import ThingBackground from './images/ThingBackground.png';
// Diagrama do equipamento no ConfigAplicacao — variantes por tema
// (light/dark) porque o design/cores mudam conforme o fundo. A selecao
// (tipo ucha/eba + tema) acontece no config-aplicacao.js.
import TGA3dLight from './images/TGA-light.png';
import TGA3dDark from './images/TGA-dark.png';
import Bomba3dLight from './images/Bomba-light.png';
import Bomba3dDark from './images/Bomba-dark.png';
import Bluebox3dLight from './images/Bluebox-light.png';
import Bluebox3dDark from './images/Bluebox-dark.png';
import FundoForm from './images/In.png';
import IconInfo from './images/IconInfo.png';
import IconCN from './images/InCN.png';
import KeyImageBackground from './icons/KeyImageBackground.svg';
//
import IconLock from './icons/IconLock.svg';
import RegisterRight from './icons/RegisterRight.svg';
import Bomba from './icons/Teste.svg';
import ConjuntoBomba from './icons/ConjuntoBomba.svg';
import LeftLine from './icons/Left.svg';
import RightLine from './icons/Right.svg';
import LogotipoWhite from './icons/LogotipoHygraWhite.svg';
import LogotipoBlue from './icons/LogotipoHygraBlue.svg';
import Logotipo from './icons/LogotipoHygra.svg';
//
import EstacoesIconNew from './icons/EstacoesIconNew.svg';
import EstacoesIconFinish from './icons/EstacoesIconFinish.svg';
import EstacoesIconEdit from './icons/EstacoesIconEdit.svg';
import EstacoesIconWhite from './icons/EstacoesIconWhite.svg';
import EstacoesIconBlue from './icons/EstacoesIconBlue.svg';
import EstacoesIconGray from './icons/EstacoesIconGray.svg';
import CadastroAcessoIconBlue from './icons/CadastroAcessoIconBlue.svg';
import PlusIconWhite from './icons/PlusIconWhite.svg';
import EditarIconGray from './icons/EditarIconGray.svg';
import EditarIconBlue from './icons/EditarIconBlue.svg';
import HelpForm from './icons/Help.svg';
import ClienteNew from './icons/ClientesNew.svg';
import ClienteEmpty from './icons/ClienteEmpty.svg';
import PlusIconBlue from './icons/PlusIconBlue.svg';
import AcessosIconEdit from './icons/AcessosIconEdit.svg';
import AcessosIconFinish from './icons/AcessosIconFinish.svg';
import AcessosIconBlue from './icons/AcessosIconBlue.svg';
import AcessosIconWhite from './icons/AcessosIconWhite.svg';
import AcessosIconGray from './icons/AcessosIconGray.svg';
import ClientesIconBlue from './icons/ClientesIconBlue.svg';
import ClientesIconWhite from './icons/ClientesIconWhite.svg';
import ClientesIconGray from './icons/ClientesIconGray.svg';
import ClientesIconFinish from './icons/ClientesIconFinish.svg';
import ClientesIconEdit from './icons/ClientesIconEdit.svg';
import DashboardIcon from './icons/DashboardIcon.svg';
import DashboardIconWhite from './icons/DashboardIconWhite.svg';
import DashboardIconGrey from './icons/DashboardIconGrey.svg';
import ConfiguracaoIcon from './icons/ConfiguracaoIcon.svg';
import ConfiguracaoIconWhite from './icons/ConfiguracaoIconWhite.svg';
import ConfiguracaoIconGrey from './icons/ConfiguracaoIconGrey.svg';
import EngrenagemIcon from './icons/EngrenagemIcon.svg';
import EngrenagemIconBlue from './icons/EngrenagemIconBlue.svg';
import EngrenagemIconLight from './icons/EngrenagemLight.svg';
import GraficoIcon from './icons/GraficoIcon.svg';
import GraficoIconWhite from './icons/GraficoIconWhite.svg';
import GraficoIconGrey from './icons/GraficoIconGrey.svg';
import NotificacaoIcon from './icons/NotificacaoIcon.svg';
import NotificacaoIconWhite from './icons/NotificacaoIconWhite.svg';
import NotificacaoIconGrey from './icons/NotificacaoIconGrey.svg';
import PlayIcon from './icons/PlayIcon.svg';
import PlayIconWhite from './icons/PlayIconWhite.svg';
import ReversePlayIcon from './icons/ReversePlayIcon.svg';
import ReversePlayIconWhite from './icons/ReversePlayIconWhite.svg';
import ConnectionIconGreen from './icons/ConnectionIconGreen.svg';
import ConnectionIconOrange from './icons/ConnectionIconOrange.svg';
import ConnectionIconRed from './icons/ConnectionIconRed.svg';
import SearchIcon from './icons/SearchIcon.svg';
import SearchIconWhite from './icons/SearchIconWhite.svg';
import MapIcon from './icons/mapIcon.svg';
import Alarme from './icons/Alarme.svg';
import Funcionando from './icons/Funcionando.svg';
import FuncionandoAlarme from './icons/FuncionandoAlarme.svg';
import Desligada from './icons/Desligada.svg';
import SemDados from './icons/SemDados.svg';
import InputDrop from './icons/InputDrop.svg';
import PersonIcon from './icons/PersonIcon.svg';
import PasswordIcon from './icons/PasswordIcon.svg';
import PhoneIcon from './icons/PhoneIcon.svg';
import EmailIcon from './icons/EmailIcon.svg';
import CloseIcon from './icons/CloseIcon.svg';
import WarningIcon from './icons/WarningIcon.svg';
import DangerIcon from './icons/DangerIcon.svg';
import FileIconLight from './icons/FolderIcon.svg';
import BinIcon from './icons/BinIcon.svg';
import BinIconLight from './icons/BinIconLight.svg';
import FileIcon from './icons/File.svg';
import FileWhite from './icons/FileWhite.svg';
import FileBlue from './icons/FileBlue.svg';
import ChangeIcon from './icons/ChangeIcon.svg';
import CheckWhite from './icons/CheckWhite.svg';
import ArrowUp from './icons/ArrowUp.svg';
import ArrowDown from './icons/ArrowDown.svg';
import Marker from './icons/Marker.svg';
import ClientPin from './icons/ClientPin.svg';
import Star from './icons/Star.svg';
import StarEmpty from './icons/StarEmpty.svg';
import UchaIcon from './icons/UchaIcon.svg';
import Sistemas from './icons/Sistemas.svg';
import MonitorCardiaco from './icons/MonitorCardiaco.png';
import Wifi from './icons/Wifi.svg';
import Scanning from './icons/Scanning.svg';
import SearchGray from './icons/SearchGray.svg';
import Evento from './icons/Evento.svg';
import EventoRed from './icons/EventoRed.svg';
import Trash from './icons/Trash.svg';
import TrashGray from './icons/TrashGray.svg';
import TrashIcon from './icons/TrashIcon.svg';
import TrashLight from './icons/TrashLight.svg';
import Turn from './icons/Turn.svg';
import Arrow from './icons/Arrow.svg';
import Flip from './icons/Flip.svg';
import Automatic from './icons/AutomaticIcon.svg';
import Rodando from './icons/RodandoIcon.svg';
import PowerPlug from './icons/PowerPlug.svg';
import MaintenanceBackground from './icons/MaintenanceBackground.svg';
import ParkIcon from './icons/ParkIcon.svg';
import History from './icons/History.svg';
import Sort from './icons/Sort.svg';
import SemDadosAlarmeIcon from './icons/SemDadosAlarme.svg';
import DesligadaAlarmeIcon from './icons/DesligadaAlarme.svg';
import ErrorAlarmeIcon from './icons/ErrorAlarme.svg';
import Chave from './icons/Chave.svg';
import IconEmail from './icons/IconEmail.svg';
import FactoryIconWhite from './icons/FactoryIconWhite.svg';
import FactoryIconGray from './icons/FactoryIconGray.svg';
import FactoryIconBlue from './icons/FactoryIconBlue.svg';
import FactoryIconNew from './icons/FactoryIconNew.svg';
import FactoryIconFinish from './icons/FactoryIconFinish.svg';
import FactoryIconEdit from './icons/FactoryIconEdit.svg';
import TipIcon from './icons/TipIcon.svg';
import AdornmentIcon from './icons/AdormentIcon.svg';
import BlockedIconWhite from './icons/BlockedIconWhite.svg';
import UnlockedIconWhite from './icons/UnlockedIconWhite.svg';
import TrashTransparent from './icons/TrashTransparent.svg';
import EyeSee from './icons/eyeSee.svg';
import EyeNotSee from './icons/eyeNotSee.svg';

export const images = {
  DefaultMapBomb,
  BombaAplicacao,
  UchaAplicacao,
  SemUsuario,
  ProdutoDefault,
  BombaFull,
  ThingBackground,
  TGA3dLight,
  TGA3dDark,
  Bomba3dLight,
  Bomba3dDark,
  Bluebox3dLight,
  Bluebox3dDark,
  FundoForm,
  IconInfo,
  IconCN,
};

export const icons = {
  EyeNotSee,
  EyeSee,
  UnlockedIconWhite,
  BlockedIconWhite,
  FactoryIconNew,
  FactoryIconFinish,
  FactoryIconEdit,
  FactoryIconWhite,
  FactoryIconGray,
  FactoryIconBlue,
  EstacoesIconNew,
  EstacoesIconFinish,
  EstacoesIconEdit,
  EstacoesIconWhite,
  EstacoesIconBlue,
  EstacoesIconGray,
  ClientesIconFinish,
  ClientesIconEdit,
  ClientesIconBlue,
  ClientesIconWhite,
  ClientesIconGray,
  AcessosIconFinish,
  AcessosIconEdit,
  AcessosIconBlue,
  AcessosIconWhite,
  AcessosIconGray,
  PlusIconBlue,
  CadastroAcessoIconBlue,
  PlusIconWhite,
  EditarIconBlue,
  EditarIconGray,
  HelpForm,
  ClienteNew,
  ClienteEmpty,
  BinIcon,
  BinIconLight,
  Automatic,
  Rodando,
  FuncionandoAlarme,
  RegisterRight,
  Bomba,
  ConjuntoBomba,
  LogotipoWhite,
  LogotipoBlue,
  Logotipo,
  LeftLine,
  RightLine,
  DashboardIcon,
  DashboardIconWhite,
  DashboardIconGrey,
  EngrenagemIcon,
  EngrenagemIconLight,
  ConfiguracaoIcon,
  ConfiguracaoIconWhite,
  ConfiguracaoIconGrey,
  GraficoIcon,
  GraficoIconWhite,
  GraficoIconGrey,
  NotificacaoIcon,
  NotificacaoIconWhite,
  NotificacaoIconGrey,
  PlayIcon,
  PlayIconWhite,
  ReversePlayIcon,
  ReversePlayIconWhite,
  ConnectionIconGreen,
  ConnectionIconOrange,
  ConnectionIconRed,
  SearchIcon,
  SearchIconWhite,
  MapIcon,
  Alarme,
  Funcionando,
  Desligada,
  SemDados,
  InputDrop,
  PersonIcon,
  PasswordIcon,
  PhoneIcon,
  EmailIcon,
  CloseIcon,
  WarningIcon,
  DangerIcon,
  FileIconLight,
  FileIcon,
  FileWhite,
  FileBlue,
  ChangeIcon,
  CheckWhite,
  ArrowUp,
  ArrowDown,
  Arrow,
  Marker,
  ClientPin,
  Star,
  StarEmpty,
  UchaIcon,
  Sistemas,
  MonitorCardiaco,
  Wifi,
  Scanning,
  SearchGray,
  ThingBackground,
  EngrenagemIconBlue,
  Evento,
  EventoRed,
  Trash,
  TrashGray,
  TrashIcon,
  TrashLight,
  TrashTransparent,
  Turn,
  Flip,
  PowerPlug,
  MaintenanceBackground,
  ParkIcon,
  History,
  Sort,
  SemDadosAlarmeIcon,
  ErrorAlarmeIcon,
  DesligadaAlarmeIcon,
  Chave,
  IconEmail,
  IconLock,
  TipIcon,
  KeyImageBackground,
  AdornmentIcon,
};

// Re-export da paleta unica (src/themes/palette.js) para retrocompatibilidade.
// Todos os arquivos que faziam `import { themes } from '../assets'` continuam
// funcionando, mas as cores agora vem da fonte unica de verdade. Para mudar
// qualquer cor, edite src/themes/palette.js.
export { themes } from '../themes/palette';
